import React from 'react';
import {
  Tile,
  TileContent,
  TileText,
} from '@one-thd/sui-atomic-components';
import { ConfirmedFilled } from '@one-thd/sui-icons';
import proptypes from 'prop-types';

const { func, string, bool, shape } = proptypes;

const ToggleTile = ({ item }) => {
  return (
    <Tile value={item.value} aria-label={item.text} selected={item.selected}>
      <TileContent>
        <span className="sui-contents">
          {item.icon}
        </span>
        <TileText>{item.text}</TileText>
        { item.selected && (
          <span className="sui-contents">
            <ConfirmedFilled size="small" />
          </span>
        )}
      </TileContent>
    </Tile>
  );
};

ToggleTile.propTypes = {
  item: shape({
    value: string,
    text: string,
    icon: func,
    selected: bool
  }).isRequired
};

export { ToggleTile };